export class RefreshTokenReqModel {
	public accessToken: string;
	public azureToken: string;
	public refreshToken: string;

	public clone(dto: any): RefreshTokenReqModel {
		if (dto.accessToken) {
			this.accessToken = dto.accessToken;
		}
		if (dto.azureToken) {
			this.azureToken = dto.azureToken;
		}
		if (dto.refreshToken) {
			this.refreshToken = dto.refreshToken;
		}

		return this;
	}

	public convert(): any {
		return {
			accessToken: this.accessToken,
			azureToken: this.azureToken,
			refreshToken: this.refreshToken,
		};
	}
}
